"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const GeozoneService = {
  createGeozones: function (options) {
    return api.post("/geozones", options, WithToken.headersToken({}, configuration.cookieName));
  },
  getGeozones: function () {
    return api.get("/geozones", WithToken.headersToken({}, configuration.cookieName));
  },
  delete: function (id) {
    return api.delete("/geozones/" + id, WithToken.headersToken({}, configuration.cookieName));
  },
  update: function (id, options, isGeometryChanged) {
    options.isGeometryChanged = isGeometryChanged;
    return api.put("/geozones/" + id, options, WithToken.headersToken({}, configuration.cookieName));
  },
  addUnit: function (id, carId) {
    return api.post(`/geozones/${id}/units/?unitId=${carId}`, {}, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteUnit: function (id, carId) {
    return api.delete(`/geozones/${id}/units/?unitId=${carId}`, WithToken.headersToken({}, configuration.cookieName));
  },
};

export default GeozoneService;
